<template>
    <div class="activity-goods-list">
        <div class="expand-form" style="margin-top:0;">
            <div style="width: 100%; " class="flex-box al-center">
                <searchForm v-model="searchData" :formItems="searchLabelList" @search="onSearch" @reset="resetForm">
                </searchForm>
            </div>
        </div>
        <myTable :index="index" :page="page" :operation="false" v-loading="loading" :table-data="tableData"
            :table-option.sync="tableOption" @page-change="getList" :expand="false">
            <template slot="goodsRange" slot-scope="scope">
                {{ scope.row.goodsRange | filtersStatus }}
            </template>
            <template slot="operation" slot-scope="scope" v-if="isEdit">
                <div style="margin: 0 0px">
                    <el-link  type="primary" :underline="false" @click="deletActive(scope.row, 'detel')"
                        style="margin-right: 10px">
                        删除
                    </el-link>
                </div>
            </template>
        </myTable>
    </div>
</template>
<script>
const ruleTypeOptions = [
    {
        name: "基准库分类",
        id: 0,
    },
    {
        name: "指定店铺",
        id: 1,
    },
    {
        name: "店铺指定商品",
        id: 2,
    },
];
import searchForm from "./searchForm.vue";
import myTable from "@/components/myTable";
import { queryActivityRuleList, activityRulesDelete } from "@/api/platActivityManage";
export default {
    components: { searchForm, myTable },
    props: {
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

            searchLabelList: [
                {
                    name: "商品范围",
                    fieldName: "goodsRange",
                    type: "select",
                    select: ruleTypeOptions,
                },
                {
                    fieldName: "date",
                    type: "daterange",
                    width: 240,
                    $attrs: {
                        placeholder: '更新时间'
                    }
                },

            ],
            searchData: this.searchDataInit(),
            loading: false,
            index: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "商品范围", prop: "goodsRange", slot: true },
                { label: "SKU活动库存下限", prop: "skuInventoryMin", },
                { label: "SKU价格上限", prop: "skuPriceMax", type: 'money' },
                { label: "更新人", prop: "updateBy", },
                { label: "更新时间", prop: "updateTime", },
                { label: "操作", prop: "operation", slot: true },
            ],

        };
    },
    filters: {
        filtersStatus(e) {
            for (let i = 0; i < ruleTypeOptions.length; i++) {
                if (e == ruleTypeOptions[i].id) {
                    return ruleTypeOptions[i].name
                }
            }
        }
    },
    created() { },
    mounted() {
        this.getList();
    },
    methods: {
        searchDataInit() {
            return {
                activityName: '',
                date: []
            }
        },
        onSearch() {
            this.page.current = 1;
            this.getList();
        },
        resetForm() {
            this.page.current = 1;
            this.searchData = this.searchDataInit();
            this.getList();
        },
        getList() {
            const { date, ...form } = this.searchData;
            const { current, size } = this.page;
            const params = {
                ...form,
                current,
                size,
                activityId: this.$route.query.id
            };
            if (date && date.length) {
                params.strTime = date[0];
                params.endTime = date[1];
            }
            queryActivityRuleList(params).then((res) => {
                this.tableData = res.records || [];
                this.page.total = res.total || 0;
            });
        },
        deletActive(row) {
            this.$confirm(`确定要删除吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    if (row.id) {
                        // 删除活动规则
                        activityRulesDelete(row.id).then((res) => {
                            this.$message.success('操作成功！')
                            this.getList()
                        }).catch((err) => { })
                    }

                })
                .catch(() => { });

        },
        goBack() {
            this.$router.back(-1)
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 97px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.activity-goods-list {
    height: 100%;
}

.expand-form {
    //   margin-top: 30px;
    //   display: flex;
    //   justify-content: space-between;
}

.flex-box {
    display: flex;
    justify-content: space-between;

    &.al-center {
        align-items: center;
    }
}
</style>
